import Panel from '../../elements/Panel';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  loading: state.shift.status.loading,
  status: state.shift.status
});

const mapDispatchToProps = dispatch => ({});

const PanelComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Panel);

export default PanelComponent;



// WEBPACK FOOTER //
// ./src/components/container/Panel/index.js